(() => {
  'use strict';

  /**
   * 链接点击绑定器 - 将指定容器内的所有 a 标签绑定到订阅弹窗功能
   */
  class LinkToPopupBinder {
    constructor(options = {}) {
      this.options = {
        containerSelector: options.containerSelector || '.validate-code',
        linkSelector: options.linkSelector || '.message a',
        ...options
      };
      this.boundContainers = new Set();
    }

    /**
     * 打开订阅弹窗
     */
    openSubscribePopup() {
      const subscribePopup = document.getElementById('subscribe-popup');

      if (!subscribePopup) return;
      if (subscribePopup.open === true) return;
      if (subscribePopup.hasAttribute && subscribePopup.hasAttribute('open')) return;
      if (subscribePopup.dataset && subscribePopup.dataset.popupOpening === 'true') return;

      if (subscribePopup.dataset) subscribePopup.dataset.popupOpening = 'true';
      try {
        subscribePopup.show();
      } finally {
        window.setTimeout(() => {
          if (subscribePopup.dataset) subscribePopup.dataset.popupOpening = 'false';
        }, 300);
      }
    }

    /**
     * 处理链接点击事件
     */
    handleLinkClick(e) {
      const link = e.target && e.target.closest ? e.target.closest(this.options.linkSelector) : null;
      if (!link) return;
      
      const container = link.closest(this.options.containerSelector);
      if (!container) return;

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      
      this.openSubscribePopup();
    }

    /**
     * 绑定单个容器的链接点击事件
     */
    bindContainer(container) {
      if (this.boundContainers.has(container)) return;

      const clickHandler = (e) => this.handleLinkClick(e);
      container.addEventListener('click', clickHandler);
      
      // 标记已绑定
      container.dataset.linkPopupBound = 'true';
      this.boundContainers.add(container);
    }

    /**
     * 初始化所有匹配的容器
     */
    init() {
      const containers = document.querySelectorAll(this.options.containerSelector);
      containers.forEach(container => this.bindContainer(container));
    }

    /**
     * 解除绑定
     */
    unbindContainer(container) {
      if (!this.boundContainers.has(container)) return;
      
      // 移除标记
      delete container.dataset.linkPopupBound;
      this.boundContainers.delete(container);
      
      // 注意：这里简化处理，实际应该保存事件处理器引用并移除
    }

    /**
     * 重新初始化（用于动态添加的元素）
     */
    reinit() {
      this.init();
    }
  }

  // 创建全局实例
  const linkPopupBinder = new LinkToPopupBinder();

  // 导出到全局（供外部调用）
  window.LinkToPopupBinder = LinkToPopupBinder;
  window.linkPopupBinder = linkPopupBinder;

})();

/**
 * 使用方法说明
 * 
 * 1. 手动绑定指定容器
 *    // 绑定单个容器内的所有 .message a 链接
 *    const myContainer = document.querySelector('.my-validate-container');
 *    window.linkPopupBinder.bindContainer(myContainer);
 * 
 * 2. 自定义选择器绑定
 *    const customBinder = new LinkToPopupBinder({
 *      containerSelector: '.my-container',  // 容器选择器
 *      linkSelector: 'a.link-popup'         // 链接选择器
 *    });
 *    customBinder.init();
 * 
 * 3. 批量绑定多个容器
 *    document.querySelectorAll('.validate-code').forEach(container => {
 *      window.linkPopupBinder.bindContainer(container);
 *    });
 * 
 * 4. 等待加载完成后再绑定（推荐用于异步场景）
 *    const waitForLinkPopupBinder = () => {
 *      if (window.linkPopupBinder) {
 *        const hasMessageLink = container.querySelector('.message a');
 *        if (hasMessageLink) {
 *          window.linkPopupBinder.bindContainer(container);
 *          console.log("成功绑定容器:", container);
 *        }
 *      } else {
 *        // 如果还没加载，等待 100ms 后重试
 *        setTimeout(waitForLinkPopupBinder, 100);
 *      }
 *    };
 *    waitForLinkPopupBinder();
 * 
 * 5. 动态元素支持
 *    // 当动态添加新元素后，手动绑定
 *    const newElement = document.querySelector('.newly-added');
 *    window.linkPopupBinder.bindContainer(newElement);
 * 
 * 6. 解除绑定
 *    window.linkPopupBinder.unbindContainer(myContainer);
 * 
 * 7. 直接调用弹窗
 *    window.linkPopupBinder.openSubscribePopup();
 * 
 * 注意事项：
 * - 不再自动绑定，需要手动调用 bindContainer()
 * - 每个容器只会绑定一次，避免重复绑定
 * - 支持事件委托，动态添加的链接也能正常工作
 * - 自动阻止链接的默认行为和冒泡
 * - 在异步加载场景中，建议使用等待机制确保对象已加载
 */
